/* eslint-disable react/jsx-no-target-blank */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import daysjs from 'dayjs';
import { GetScrollTimeStyle } from '@app/utils/Css';

const physicalEvent = 'Physical event';
const onlineEvent = 'Online event';
const fundraiser = 'Fundraiser';

export class EventCard extends Component {
	render() {
		return (
			<div className="hit-card">
				<a
					className="hit-card-link"
					href={this.props.productUrl}
					alt="event"
					target="_blank"
				>
					<img
						src={this.props.imageUrl}
						alt={this.props.productName}
					/>
					<div className="hit-card-desc">
						<h3 className="hit-card-title-small">
							<span
								className={
									this.props.productName.length > 24
										? 'title-scroll'
										: ''
								}
								style={GetScrollTimeStyle(
									this.props.productName.length,
								)}
							>
								{this.props.productName}
							</span>
						</h3>
						<h4 className="hit-card-venue">
							{this.props.venueName
								? this.props.venueName
								: 'ONLINE'}
						</h4>
						{this.props.type === physicalEvent && (
							<div className="hit-card-footer">
								<span className="hit-card-footer-desc">
									{this.props.isOngoing === true
										? 'Runs from '
										: ''}
									{daysjs(this.props.dateFrom).format(
										'ddd D MMM YYYY',
									)}
								</span>
								<span className="hit-card-footer-desc">
									{daysjs(this.props.dateFrom).format(
										'HH:mm',
									)}
								</span>
							</div>
						)}
						{this.props.type === onlineEvent && (
							<div className="hit-card-footer">
								<span className="hit-card-footer-desc">
									{this.props.isOngoing === true
										? 'Runs from '
										: ''}
									{daysjs(this.props.dateFrom).format(
										'ddd D MMM YYYY',
									)}
								</span>
								<span className="hit-card-footer-desc">
									{daysjs(this.props.dateFrom).format(
										'HH:mm',
									)}
								</span>
							</div>
						)}
						{this.props.type === fundraiser && (
							<div className="hit-card-footer">
								<span className="hit-card-footer-desc-fundraiser">
									.
								</span>
							</div>
						)}
					</div>
				</a>
			</div>
		);
	}
}

EventCard.propTypes = {
	productUrl: PropTypes.string,
	imageUrl: PropTypes.string,
	productName: PropTypes.string,
	venueName: PropTypes.string,
	dateFrom: PropTypes.string,
	isOngoing: PropTypes.bool,
	type: PropTypes.string,
};

export default EventCard;
